import {restAuthStorage} from './restAuthStorage';
let pending: Promise<string> | undefined;
export async function refreshRestSession(apiKey: string): Promise<string> {
  const raw = restAuthStorage.getItem('finflow_auth');
  if (!raw) throw new Error('Please sign in to FinFlow.');
  const session = JSON.parse(raw);
  if (session.idToken && Date.now() - session.timestamp < 55 * 60 * 1000) return session.idToken;
  if (!session.refreshToken) throw new Error('Please sign in to FinFlow again.');
  if (pending) return pending;
  pending = (async () => {
    const response = await fetch(`https://securetoken.googleapis.com/v1/token?key=${encodeURIComponent(apiKey)}`, {
      method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ grant_type: 'refresh_token', refresh_token: session.refreshToken }).toString()
    });
    const data = await response.json();
    if (!response.ok) {
      if (['TOKEN_EXPIRED', 'USER_DISABLED', 'USER_NOT_FOUND', 'INVALID_REFRESH_TOKEN'].includes(data.error?.message) && restAuthStorage.getItem('finflow_auth') === raw) restAuthStorage.removeItem('finflow_auth');
      throw new Error('Your session could not be refreshed. Check your connection and try again.');
    }
    if (!data.id_token || !data.refresh_token || data.user_id !== session.uid) throw new Error('Session verification failed.');
    if (restAuthStorage.getItem('finflow_auth') !== raw) throw new Error('The signed-in account changed. Please try again.');
    restAuthStorage.setItem('finflow_auth', JSON.stringify({ ...session, idToken: data.id_token, refreshToken: data.refresh_token, timestamp: Date.now() }));
    return data.id_token;
  })();
  try { return await pending; } finally { pending = undefined; }
}
